import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Share, ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { result, toLower } from 'lodash';
import { catchError, delay } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import {
    GetOption,
    HateoasResourceOperation,
    HttpMethod,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { take, tap } from 'rxjs/operators';
import { HTTP_CLIENT, TokenService } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class ShareService extends HateoasResourceOperation<Share> {
    apiUrl;
    appsUrl;
    model: Share | null = null;
    networkPricing = 199.0;
    regionPricing = [{ region: null, price: 0.2, rate: 'GB' }];
    lastPageCount = 0;
    lastTotalCount = 0;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };

    constructor(
        private logger: LoggerService,
        private tokenService: TokenService,
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(Share);
        this.apiUrl = this.environment.frontdoorURL;

    }


    public findShares(options?: PagedGetOption): Promise<Share[]> {
        return super
            .getPage({ ...ShareService.defaultHttpAccept, ...options })
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((shares) => (shares ? shares.resources : []));
    }


    public create(frontdoorId: string, model) {
        const fullpath = `${this.apiUrl}/${frontdoorId}/shares`
        return this.http
        .post(fullpath, model)
    }

    public delete(frontdoorId: string, id: string) {
        const fullpath = `${this.apiUrl}/${frontdoorId}/shares/${id}`
        return this.http
        .delete(fullpath)
    }


    public getShares(frontdoorId: string) {
        const fullpath = `${this.apiUrl}/${frontdoorId}/shares`
        return this.http
        .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }
    
    public getSparklinesByShare(frontdoorId: string, shareToken: string) {
        const fullpath = `${this.apiUrl}/${frontdoorId}/sparklines?shares=${shareToken}`
        return this.http
        .get(fullpath, {
        headers: { Accept: 'application/hal+json' }})
    } 
    
    public setModel(data: Share) {
        this.model = data;
    }


    getModel(): Share | null {
        return this.model;
    }



    /**
     * @param path
     * @param data
     */
    public post(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.post(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * @param path
     * @param data
     */
    public put(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.put(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * Generic GETter
     */

    public get(path: string) {
        const fullpath = `${this.apiUrl}${path}`;

        return this.http.get(fullpath, { headers: this.setHeaders() });
    }

    /**
     * Return headers
     */
    private setHeaders(): HttpHeaders {
        const headers = new HttpHeaders();

                  return headers.append('Content-Type', 'application/json');
    }

        /**
     * Generic error handler for bad requests
     */
        protected handleError(scope: any, error: HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                scope.logger.error('Feature Service error occurred:', error.error);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                scope.logger.error(`Feature Backend returned code ${error.status}`, error.error);
            }
            scope.lastErrorSource.next(error);
            return observableThrowError(error);
        }
}
